<template>
  <v-tooltip left>
    <template v-slot:activator="{ on }">
      <v-btn :id="id" fab bottom right fixed dark :color="color" :to="to" v-on="on">
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ $t(tooltipText) }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'FabButton',

  props: {
    id: {
      type: String,
      default: undefined
    },
    color: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String,
      default: 'mdi-plus'
    },
    tooltipText: {
      type: String,
      default: 'add'
    },
    to: {
      type: String,
      default: undefined
    }
  }
}
</script>
